/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of pattern approved device make and model
 */
export enum PatternApproved {
	APPROVED = 'Approved',
	NOT_APPROVED = 'Not Approved',
	EXISTING_APPROVED = 'Existing Approved',
}
